import { STRUCTURE_GRID_SIZE } from 'data/constants';
import { PositionType } from 'data/types';
import {
  FootprintShapeDragData,
  FootprintShapeDropAction,
  FootprintShapeDropTarget,
  RectPositionType
} from './footprint-shape-drag-types';
import { STEP_SIDEBAR_DROP_ZONE_ID } from './step-sidebar-drop-zone';

export const FOOTPRINT_SHAPE_DRAG_TYPE = 'grid-footprint-shape';

const ZERO_DELTA: PositionType = { x: 0, y: 0 };

export function footprintShapeDraggableId(shapeIndex: number): string {
  return `footprint-shape-${shapeIndex}`;
}

export function createFootprintShapeDragData(
  shapeIndex: number
): FootprintShapeDragData {
  return { type: FOOTPRINT_SHAPE_DRAG_TYPE, shapeIndex };
}

export function getDraggedFootprintShapeIndex(data: unknown): number | null {
  if (!data || typeof data !== 'object') return null;
  const { type, shapeIndex } = data as Partial<FootprintShapeDragData>;
  if (type !== FOOTPRINT_SHAPE_DRAG_TYPE) return null;
  return typeof shapeIndex === 'number' ? shapeIndex : null;
}

export function isSameGridDelta(
  a: PositionType | null | undefined,
  b: PositionType
): boolean {
  return !!a && a.x === b.x && a.y === b.y;
}

export function footprintShapeGridDelta(
  initial: RectPositionType | null,
  translated: RectPositionType | null,
  zoom: number
): PositionType {
  if (!initial || !translated) return ZERO_DELTA;
  const step = STRUCTURE_GRID_SIZE * (zoom > 0 ? zoom : 1);
  return {
    x: Math.round((translated.left - initial.left) / step),
    y: Math.round((translated.top - initial.top) / step)
  };
}

export function isStepSidebarDropTarget(
  over: FootprintShapeDropTarget
): boolean {
  return over !== null && String(over.id) === STEP_SIDEBAR_DROP_ZONE_ID;
}

export function resolveFootprintShapeDrop(
  shapeIndex: number,
  over: FootprintShapeDropTarget,
  delta: PositionType
): FootprintShapeDropAction {
  if (isStepSidebarDropTarget(over)) return { kind: 'delete', shapeIndex };
  if (isSameGridDelta(delta, ZERO_DELTA)) return { kind: 'none' };
  return { kind: 'move', shapeIndex, delta };
}

export function footprintShapePreviewTransform(
  delta: PositionType | null
): string | undefined {
  if (!delta || isSameGridDelta(delta, ZERO_DELTA)) return undefined;
  return `translate(${delta.x * STRUCTURE_GRID_SIZE} ${
    delta.y * STRUCTURE_GRID_SIZE
  })`;
}
